import { MutationTree } from 'vuex'
import { NotesState } from '@/store/modules/notes/types'

export enum NoteMutations {
  SET_NOTES = 'SET_REPORTS',
  TRIGGER_LOADING = 'TRIGGER_LOADING'
}

export const mutations: MutationTree<NotesState> = {
  [NoteMutations.SET_NOTES] (state, payload) {
    state.notes = payload
  },

  [NoteMutations.TRIGGER_LOADING] (state, bool: boolean) {
    state.loading = bool
  }
}
